export const roleMap = {
    REPRESENTATIVE: "NÜMAYƏNDƏ",
    CONTROLLER: "NƏZARƏTÇİ",
    ADMIN: "ADMIN",
    SUPER_ADMIN: "SUPER ADMIN"
}

export default [
    {
        "id": 1,
        "name": "REPRESENTATIVE",
        "name_az": "NÜMAYƏNDƏ"
    },
    {
        "id": 2,
        "name": "CONTROLLER",
        "name_az": "NƏZARƏTÇİ"
    },
    {
        "id": 3,
        "name": "ADMIN",
        "name_az": "ADMIN"
    },
    {
        "id": 4,
        "name": "SUPER_ADMIN",
        "name_az": "SUPER ADMIN"
    }
]